import React from 'react'
import { withIcon } from '../../withIcon'

function SortTilesDescIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.625 5.625V9.375H9.375V5.625H5.625ZM4.375 5.5C4.375 4.87868 4.87868 4.375 5.5 4.375H9.5C10.1213 4.375 10.625 4.87868 10.625 5.5V9.5C10.625 10.1213 10.1213 10.625 9.5 10.625H5.5C4.87868 10.625 4.375 10.1213 4.375 9.5V5.5ZM17 5.375C17.3452 5.375 17.625 5.65482 17.625 6V16.4911L19.5581 14.5581C19.8021 14.314 20.1979 14.314 20.4419 14.5581C20.686 14.8021 20.686 15.1979 20.4419 15.4419L17.4419 18.4419C17.1979 18.686 16.8021 18.686 16.5581 18.4419L13.5581 15.4419C13.314 15.1979 13.314 14.8021 13.5581 14.5581C13.8021 14.314 14.1979 14.314 14.4419 14.5581L16.375 16.4911V6C16.375 5.65482 16.6548 5.375 17 5.375ZM5.625 14.625V18.375H9.375V14.625H5.625ZM4.375 14.5C4.375 13.8787 4.87868 13.375 5.5 13.375H9.5C10.1213 13.375 10.625 13.8787 10.625 14.5V18.5C10.625 19.1213 10.1213 19.625 9.5 19.625H5.5C4.87868 19.625 4.375 19.1213 4.375 18.5V14.5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SortTilesDescIcon)
